// Angular Imports
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// My Account Imports
import { LifePolicy } from '@amfam/policy/models';

@Component({
  selector: 'life-risk-card',
  templateUrl: './life-risk-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['../policy-risk-card.scss'],
  standalone: false
})
export class LifeRiskCardComponent {
  @Input() policy: LifePolicy;
  @Input() phoneNumber: string;
  @Input() newTemplate: boolean = false;
}
